import { useLayoutEffect, useRef, useState } from "react"
import { useLocation, useNavigate, useOutletContext } from "react-router-dom"
import { useSWRConfig } from "swr"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import { Transition } from "components"
import { useAuth } from "contexts/auth-context"
import Form from "./form"
import { insertSuratJalanUmum } from "./api"

export default function Create({ title }) {
  const { user } = useAuth()
  const { cache } = useSWRConfig()
  const { setTitle } = useOutletContext()
  const location = useLocation()
  const navigate = useNavigate()

  const [errors, setErrors] = useState({})
  const [submitting, setSubmitting] = useState(false)
  const submittingRef = useRef(false)

  useLayoutEffect(() => {
    setTitle("Tambah Surat Jalan Umum")
  }, [])

  const handleSubmit = async (payload) => {
    if (submittingRef.current) return
    submittingRef.current = true
    setSubmitting(true)
    setErrors({})
    nProgress.start()
    toast.loading("Menyimpan", { id: "sju-submit" })

    try {
      const result = await insertSuratJalanUmum(payload, user?.name)
      cache.clear()
      toast.success(result?.message || "Surat Jalan Umum tersimpan", { id: "sju-submit" })
      navigate("/surat-jalan-umum", { replace: true, state: { transition: "slide" } })
    } catch (err) {
      if (err?.validation && typeof err.validation === "object") setErrors(err.validation)
      toast.error(err?.message || "Gagal menyimpan", { id: "sju-submit" })
    } finally {
      submittingRef.current = false
      setSubmitting(false)
      nProgress.done()
    }
  }

  return (
    <Transition type="fade">
      <Form errors={errors} onSubmit={handleSubmit} submitting={submitting} />
    </Transition>
  )
}
